export default "<div class=\"progress-bar\" style=\"--value2: {{progress}}; --value1: {{progress}}%\">\n</div>\n";